"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = themeBus;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _globals = require("../../../globals.js");

var _omit = _interopRequireDefault(require("lodash/omit"));

var _deprecatedThemeProps = _interopRequireDefault(require("./deprecatedThemeProps"));

function themeBus(theme) {
  var _label, _underscore, _result;

  theme = theme || {};
  var result = (_result = {}, (0, _defineProperty2["default"])(_result, _globals.STATE.HOVER, {}), (0, _defineProperty2["default"])(_result, _globals.STATE.FOCUS, {}), (0, _defineProperty2["default"])(_result, _globals.STATE.ERROR, {}), (0, _defineProperty2["default"])(_result, _globals.STATE.DISABLED, {}), (0, _defineProperty2["default"])(_result, "label", (_label = {}, (0, _defineProperty2["default"])(_label, _globals.STATE.HOVER, {}), (0, _defineProperty2["default"])(_label, _globals.STATE.FOCUS, {}), (0, _defineProperty2["default"])(_label, _globals.STATE.ERROR, {}), (0, _defineProperty2["default"])(_label, _globals.STATE.DISABLED, {}), _label)), (0, _defineProperty2["default"])(_result, "underscore", (_underscore = {}, (0, _defineProperty2["default"])(_underscore, _globals.STATE.HOVER, {}), (0, _defineProperty2["default"])(_underscore, _globals.STATE.FOCUS, {}), (0, _defineProperty2["default"])(_underscore, _globals.STATE.ERROR, {}), (0, _defineProperty2["default"])(_underscore, _globals.STATE.DISABLED, {}), _underscore)), _result);

  if (theme.idleColor) {
    result.color = theme.idleColor;
  }

  if (theme.idlePlaceholder) {
    result.placeholder = theme.idlePlaceholder;
  }

  if (theme.idleBorderColor) {
    result.borderColor = theme.idleBorderColor;
    result.underscore.borderColor = theme.idleBorderColor;
  }

  if (theme.idleBorderStyle) {
    result.borderStyle = theme.idleBorderStyle;
    result.underscore.borderStyle = theme.idleBorderStyle;
  }

  if (theme.idleBorderWidth) {
    result.borderWidth = theme.idleBorderWidth;
    result.underscore.borderWidth = theme.idleBorderWidth;
  }

  if (theme.idleBorderRadius) {
    result.borderRadius = theme.idleBorderRadius;
  }

  if (theme.idleBackground) {
    result.background = theme.idleBackground;
  }

  if (theme.idleBoxShadow) {
    result.boxShadow = theme.idleBoxShadow;
  }

  if (theme.idleOutline) {
    result.outline = theme.idleOutline;
  }

  if (theme.hoverColor) {
    result[_globals.STATE.HOVER].color = theme.hoverColor;
  }

  if (theme.hoverPlaceholder) {
    result[_globals.STATE.HOVER].placeholder = theme.hoverPlaceholder;
  }

  if (theme.hoverBorderColor) {
    result[_globals.STATE.HOVER].borderColor = theme.hoverBorderColor;
    result.underscore[_globals.STATE.HOVER].borderColor = theme.hoverBorderColor;
  }

  if (theme.hoverBorderStyle) {
    result[_globals.STATE.HOVER].borderStyle = theme.hoverBorderStyle;
    result.underscore[_globals.STATE.HOVER].borderStyle = theme.hoverBorderStyle;
  }

  if (theme.hoverBorderWidth) {
    result[_globals.STATE.HOVER].borderWidth = theme.hoverBorderWidth;
    result.underscore[_globals.STATE.HOVER].borderWidth = theme.hoverBorderWidth;
  }

  if (theme.hoverBorderRadius) {
    result[_globals.STATE.HOVER].borderRadius = theme.hoverBorderRadius;
  }

  if (theme.hoverBackground) {
    result[_globals.STATE.HOVER].background = theme.hoverBackground;
  }

  if (theme.hoverBoxShadow) {
    result[_globals.STATE.HOVER].boxShadow = theme.hoverBoxShadow;
  }

  if (theme.hoverOutline) {
    result[_globals.STATE.HOVER].outline = theme.hoverOutline;
  }

  if (theme.focusColor) {
    result[_globals.STATE.FOCUS].color = theme.focusColor;
  }

  if (theme.focusPlaceholder) {
    result[_globals.STATE.FOCUS].placeholder = theme.focusPlaceholder;
  }

  if (theme.focusBorderColor) {
    result[_globals.STATE.FOCUS].borderColor = theme.focusBorderColor;
    result.underscore[_globals.STATE.FOCUS].borderColor = theme.focusBorderColor;
  }

  if (theme.focusBorderStyle) {
    result[_globals.STATE.FOCUS].borderStyle = theme.focusBorderStyle;
    result.underscore[_globals.STATE.FOCUS].borderStyle = theme.focusBorderStyle;
  }

  if (theme.focusBorderWidth) {
    result[_globals.STATE.FOCUS].borderWidth = theme.focusBorderWidth;
    result.underscore[_globals.STATE.FOCUS].borderWidth = theme.focusBorderWidth;
  }

  if (theme.focusBorderRadius) {
    result[_globals.STATE.FOCUS].borderRadius = theme.focusBorderRadius;
  }

  if (theme.focusBackground) {
    result[_globals.STATE.FOCUS].background = theme.focusBackground;
  }

  if (theme.focusBoxShadow) {
    result[_globals.STATE.FOCUS].boxShadow = theme.focusBoxShadow;
  }

  if (theme.focusOutline) {
    result[_globals.STATE.FOCUS].outline = theme.focusOutline;
  }

  if (theme.errorColor) {
    result[_globals.STATE.ERROR].color = theme.errorColor;
  }

  if (theme.errorPlaceholder) {
    result[_globals.STATE.ERROR].placeholder = theme.errorPlaceholder;
  }

  if (theme.errorBorderColor) {
    result[_globals.STATE.ERROR].borderColor = theme.errorBorderColor;
    result.underscore[_globals.STATE.ERROR].borderColor = theme.errorBorderColor;
  }

  if (theme.errorBorderStyle) {
    result[_globals.STATE.ERROR].borderStyle = theme.errorBorderStyle;
    result.underscore[_globals.STATE.ERROR].borderStyle = theme.errorBorderStyle;
  }

  if (theme.errorBorderWidth) {
    result[_globals.STATE.ERROR].borderWidth = theme.errorBorderWidth;
    result.underscore[_globals.STATE.ERROR].borderWidth = theme.errorBorderWidth;
  }

  if (theme.borderRadius) {
    result[_globals.STATE.ERROR].borderRadius = theme.borderRadius;
  }

  if (theme.errorBackground) {
    result[_globals.STATE.ERROR].background = theme.errorBackground;
  }

  if (theme.errorBoxShadow) {
    result[_globals.STATE.ERROR].boxShadow = theme.errorBoxShadow;
  }

  if (theme.errorOutline) {
    result[_globals.STATE.ERROR].outline = theme.errorOutline;
  }

  if (theme.disabledColor) {
    result[_globals.STATE.DISABLED].color = theme.disabledColor;
  }

  if (theme.disabledPlaceholder) {
    result[_globals.STATE.DISABLED].placeholder = theme.disabledPlaceholder;
  }

  if (theme.disabledBorderColor) {
    result[_globals.STATE.DISABLED].borderColor = theme.disabledBorderColor;
    result.underscore[_globals.STATE.DISABLED].borderColor = theme.disabledBorderColor;
  }

  if (theme.disabledBorderStyle) {
    result[_globals.STATE.DISABLED].borderStyle = theme.disabledBorderStyle;
    result.underscore[_globals.STATE.DISABLED].borderStyle = theme.disabledBorderStyle;
  }

  if (theme.disabledBorderWidth) {
    result[_globals.STATE.DISABLED].borderWidth = theme.disabledBorderWidth;
    result.underscore[_globals.STATE.DISABLED].borderWidth = theme.disabledBorderWidth;
  }

  if (theme.disabledBorderRadius) {
    result[_globals.STATE.DISABLED].borderRadius = theme.disabledBorderRadius;
  }

  if (theme.disabledBackground) {
    result[_globals.STATE.DISABLED].background = theme.disabledBackground;
  }

  if (theme.disabledBoxShadow) {
    result[_globals.STATE.DISABLED].boxShadow = theme.disabledBoxShadow;
  }

  if (theme.disabledOutline) {
    result[_globals.STATE.DISABLED].outline = theme.disabledOutline;
  }

  if (theme.labelFontSize) {
    result.label.fontSize = theme.labelFontSize;
  }

  if (theme.labelLineHeight) {
    result.label.lineHeight = theme.labelLineHeight;
  }

  if (theme.labelOverflow) {
    result.label.overflow = theme.labelOverflow;
  }

  if (theme.labelPaddingLeft) {
    result.label.paddingLeft = theme.labelPaddingLeft;
  }

  if (theme.labelPaddingRight) {
    result.label.paddingRight = theme.labelPaddingRight;
  }

  if (theme.idleLabelColor) {
    result.label.color = theme.idleLabelColor;
  }

  if (theme.hoverLabelColor) {
    result.label[_globals.STATE.HOVER].color = theme.hoverLabelColor;
  }

  if (theme.focusLabelColor) {
    result.label[_globals.STATE.FOCUS].color = theme.focusLabelColor;
  }

  if (theme.errorLabelColor) {
    result.label[_globals.STATE.ERROR].color = theme.errorLabelColor;
  }

  if (theme.disabledLabelColor) {
    result.label[_globals.STATE.DISABLED].color = theme.disabledLabelColor;
  }

  if (theme.idleBorderTransform) {
    result.underscore.borderTransform = theme.idleBorderTransform;
  }

  if (theme.hoverBorderTransform) {
    result.underscore[_globals.STATE.HOVER].borderTransform = theme.hoverBorderTransform;
  }

  if (theme.focusBorderTransform) {
    result.underscore[_globals.STATE.FOCUS].borderTransform = theme.focusBorderTransform;
  }

  if (theme.errorBorderTransform) {
    result.underscore[_globals.STATE.ERROR].borderTransform = theme.errorBorderTransform;
  }

  if (theme.disabledBorderTransform) {
    result.underscore[_globals.STATE.DISABLED].borderTransform = theme.disabledBorderTransform;
  }

  return (0, _omit["default"])(result, _deprecatedThemeProps["default"]);
}